<template>
  <BModal
    ref="modalMemo"
    size="lg"
    title="Task"
    scrollable
    centered
    hide-header
    no-close-on-esc
    no-enforce-focus
    no-close-on-backdrop
    content-class="scrollable-tabs"
    modal-class="full-height modal-no-padding"
    aria-hidden="false"
    role="dialog"
    @shown="eventModalShown"
    @hidden="eventModalHidden"
  >
    <BTabs
      active-nav-item-class="font-weight-bold text-primary"
      nav-class="scrollable-x-tabs no-scrollbar nav-customer-memo-tabs gap-x-1"
      content-class="scrollable"
      pills
    >
      <template #tabs-start>
        <div class="nav-item">
          <div
            class="d-flex align-items-center position-absolute"
            style="padding: 2px 1px; height: 38px;"
          >
            <i
              class="fas fa-chevron-left bg-primary-light p-1 rounded-lg"
              style="font-size: 20px;"
            />
          </div>
        </div>
      </template>
      <template #tabs-end>
        <div class="nav-item">
          <div
            class="d-flex align-items-center position-absolute"
            style="right: 20px; padding: 2px 1px; height: 38px;"
          >
            <i
              class="fas fa-chevron-right bg-primary-light p-1 rounded-lg"
              style="font-size: 20px;"
            />
          </div>
        </div>
      </template>
      <BTab
        class="p-2 min-h-400px"
      >
        <template #title>
          <div class="text-md-nowrap">
            <i
              :class="['fa-xl fad fa-file-lines', {
                'text-danger fat fa-shake': vTabEventDetails()
              }]"
            />
            <b
              :class="['is-tab-active ml-1', {
                'text-danger': vTabEventDetails()
              }]"
            >
              Details
            </b>
          </div>
        </template>

        <ValidationObserver
          ref="formMemo"
        >
          <form
            role="form"
            novalidate
            @submit.prevent
          >
            <BRow>

              <BCol
                cols="12"
                md="3"
              >
                <BFormGroup
                  label="Code"
                  label-for="fCustomerCode"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormInput
                    id="fCustomerCode"
                    v-model="customer.customer_code"
                    placeholder="no selected customer"
                    disabled
                  />
                </BFormGroup>
              </BCol>

              <BCol
                cols="12"
                md="3"
              >
                <BFormGroup
                  label="Cluster"
                  label-for="fCluster"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormInput
                    id="fCluster"
                    v-model="customer.cluster_name"
                    placeholder="no selected customer"
                    disabled
                  />
                </BFormGroup>
              </BCol>

              <BCol
                cols="12"
              >
                <BFormGroup
                  label="Customer"
                  label-for="fCustomerName"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormTextarea
                    id="fRemarks"
                    v-model="customer.customer_name"
                    rows="2"
                    max-rows="4"
                    placeholder="no selected customer"
                    disabled
                  />
                </BFormGroup>
              </BCol>

              <BCol
                cols="12"
              >
                <BFormGroup
                  label="Contact Person"
                  label-for="fContactPerson"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormInput
                    id="fContactPerson"
                    v-model="customer.contact_person"
                    placeholder="no selected customer"
                    disabled
                  />
                </BFormGroup>
              </BCol>

              <BCol
                cols="12"
              >
                <BFormGroup
                  label="Address"
                  label-for="fAddress"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormTextarea
                    id="fAddress"
                    v-model="customer.address"
                    rows="2"
                    max-rows="12"
                    placeholder="no address"
                    disabled
                  />
                </BFormGroup>
              </BCol>

              <BCol
                cols="12"
              >
                <BFormGroup
                  label="Customer Memo"
                  label-for="fCustomerMemo"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormTextarea
                    id="fCustomerMemo"
                    v-model="formMemo.customer_memo_name"
                    rows="2"
                    max-rows="12"
                    placeholder="no customer memo"
                    disabled
                  />
                </BFormGroup>
              </BCol>

              <BCol
                cols="12"
                md="3"
              >
                <BFormGroup
                  label="Month"
                  label-for="fMonth"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormInput
                    id="fMonth"
                    v-model="formMemo.schedule"
                    placeholder="no selected month"
                    disabled
                  />
                </BFormGroup>
              </BCol>

              <BCol
                cols="12"
                md="3"
              >
                <ValidationProvider
                  v-slot="{ errors }"
                  vid="event_date"
                  name="event date"
                  rules="required"
                >
                  <BFormGroup
                    label="Event Date"
                    label-for="fEventDate"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fEventDate"
                      v-model="formMemo.event_date"
                      type="date"
                      :min="formMemoValidation.rangeDate.min"
                      :max="formMemoValidation.rangeDate.max"
                      :state="errors.length > 0 ? false : null"
                      :disabled="state.busy"
                    />
                    <div
                      v-if="(errors.length > 0)"
                      class="invalid-feedback"
                      v-text="errors[0]"
                    />
                  </BFormGroup>
                </ValidationProvider>
              </BCol>

              <BCol
                cols="6"
                md="3"
              >
                <ValidationProvider
                  v-slot="{ errors }"
                  vid="is_signed"
                  name="is signed"
                  rules="required"
                >
                  <BFormGroup
                    label="Is Signed?"
                    label-for="fIsSigned"
                    :label-class="`font-weight-bolder text-${Number(formMemo.is_signed) === 1? 'primary' : 'danger'}`"
                    class="mb-2"
                  >
                    <BFormSelect
                      id="fIsSigned"
                      v-model="formMemo.is_signed"
                      :options="options.yesOrNos"
                      :state="errors.length > 0 ? false : null"
                      :disabled="state.busy"
                    >
                      <template #first>
                        <BFormSelectOption
                          value=""
                          disabled
                          v-text="' - - select here - - '"
                        />
                      </template>
                    </BFormSelect>
                    <div
                      v-if="(errors.length > 0)"
                      class="invalid-feedback"
                      v-text="errors[0]"
                    />
                  </BFormGroup>
                </ValidationProvider>
              </BCol>

              <BCol
                cols="12"
              >
                <ValidationProvider
                  v-slot="{ errors }"
                  vid="remarks"
                  name="remarks"
                  rules="max:1000"
                >
                  <BFormGroup
                    label="Remarks"
                    label-for="fRemarks"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <template #label>
                      <span class="d-flex justify-content-between">
                        Remarks
                        <span>
                          {{ formMemo.remarks ? formMemo.remarks.length : 0 }} / 1000
                        </span>
                      </span>
                    </template>
                    <BFormTextarea
                      id="fRemarks"
                      v-model="formMemo.remarks"
                      rows="5"
                      max-rows="12"
                      maxlength="1000"
                      placeholder="enter remarks here (optional)"
                      :state="errors.length > 0 ? false : null"
                      :disabled="state.busy"
                    />
                    <div
                      v-if="(errors.length > 0)"
                      class="invalid-feedback"
                      v-text="errors[0]"
                    />
                  </BFormGroup>
                </ValidationProvider>
              </BCol>
            </BRow>

          </form>
        </ValidationObserver>
      </BTab>

      <BTab
        class="p-2 min-h-400px"
      >
        <template #title>
          <div class="text-md-nowrap">
            <i
              :class="['fa-xl fad fa-paperclip', {
                'text-danger fat fa-shake': vTabAttachments()
              }]"
            />
            <b
              :class="['is-tab-active ml-1', {
                'text-danger': vTabAttachments()
              }]"
            >
              Attachments
            </b>
          </div>
        </template>
        <Attachment
          ref="attachmentUploader"
          :loading="state.busy"
          :valid-id="formMemo.id"
          :path="formMemo.attachment_path"
          :files="formMemo.attachments"
          :deleted-files="formMemo.deleted_files"
          :document-types="formMemoValidation.documents"
          @files:updated="updateCustomerMemoDocuments"
        />
      </BTab>
    </BTabs>
    <template #modal-footer="{ cancel }">
      <BButton
        variant="primary"
        :disabled="state.busy"
        @click.prevent="validateCustomerMemo"
      >
        {{ state.editing ? 'Update' : 'Submit' }}
      </BButton>
      <BButton
        variant="outline-dark"
        :disabled="state.busy"
        @click.prevent="discardBtnEvent => preventAriaHidden(discardBtnEvent, cancel)"
      >
        Discard
      </BButton>
    </template>

  </BModal>
</template>
<script>
import { mapGetters } from 'vuex'
import { GeolocateControl, Map, NavigationControl } from 'maplibre-gl'
import FPMonthSelect from 'flatpickr/dist/plugins/monthSelect'
import imgLogo from '@/assets/images/logo-clean.jpg'
import moment from 'moment'
import { find } from 'lodash'

import Attachment from '@/views/fso/customer-memos/components/Attachment.vue'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'

import { SFSOCustomerMemo } from '@/services/fso'

export default {
  name: 'FSOCustomerMemosCrud',

  components: {
    Attachment
  },

  mixins: [
    MxMisc,
    MxFormatter
  ],

  emits: [
    'update:row',
    'update:rows'
  ],

  data () {
    return {
      geoLocationId: null,
      flatPickerConfig: {
        appendTo: document.body,
        altInput: true,
        allowInput: true,
        disableMobile: true,
        plugins: [
          new FPMonthSelect({
            dateFormat: 'Y-m',
            altFormat: 'F Y'
          })
        ]
      },
      state: {
        busy: false,
        editing: false
      },
      options: {
        yesOrNos: [
          { value: 1, text: 'Yes' },
          { value: 0, text: 'No' }
        ]
      },
      customer: {
        cluster_name: '',
        customer_code: '',
        customer_name: '',
        contact_person: '',
        address: ''
      },
      formMemoValidation: {
        documents: [
          { id: 1, document_type_name: 'Picture with the Customer', required: 1 },
          { id: 2, document_type_name: 'Picture of the Commercial Trading Terms ( Signed / Unsigned )', required: 1 },
          { id: 3, document_type_name: 'Picture of the Business Plan Agreements ( Signed / Unsigned )', required: 1 }
        ],
        rangeDate: {
          min: moment().subtract(2, 'years').startOf('year').format('YYYY-MM-DD'),
          max: moment().endOf('month').format('YYYY-MM-DD')
        }
      },
      formMemo: {
        id: '',
        customer_memo_id: '',
        customer_memo_name: '',
        schedule: '',
        event_date: '',
        remarks: '',
        attachment_path: '',
        attachments: [],
        deleted_files: [],
        is_signed: 0
      }
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    }),

    MMemoTitle () {
      return this.state.editing ? 'Process Customer Memo' : 'Create Customer Memo'
    }
  },

  watch: {
    'selected.fsOfficer' (officer) {
      this.formMemo.assignee_id = officer?.id || ''
    },

    'selected.customer' (customer) {
      this.formMemo.customer_id = customer?.id || ''
    }
  },

  methods: {

    vTabEventDetails () {
      if (this.$refs.formMemo) {
        const formMemoErrors = this.$refs.formMemo.errors

        return Object.keys(formMemoErrors).some(
          errorKey => formMemoErrors[errorKey]?.length > 0
        )
      }

      return false
    },

    vTabAttachments () {
      if (this.$refs.attachmentUploader) {
        const formDocument = this.$refs.attachmentUploader.$refs.formDocument

        if (formDocument) {
          return Object.keys(formDocument.errors).some(
            errorKey => formDocument.errors[errorKey]?.length > 0
          )
        }
      }

      return false
    },

    createMemo (memo) {
      this.state.editing = false

      const dateFormat = 'YYYY-MM-DD'

      const minDay = moment(memo.schedule).subtract(2, 'years').startOf('year')
      const maxDay = moment(memo.schedule).add(50, 'years').endOf('year')

      this.formMemoValidation.rangeDate = Object.assign(this.formMemoValidation.rangeDate, {
        min: minDay.startOf('month').format(dateFormat),
        max: maxDay.endOf('month').format(dateFormat)
      })

      this.formMemoValidation.documents = memo.memo?.documents || []

      const clusters = memo.assignee?.clusters || []
      const cluster = find(clusters, { id: memo.customer?.cluster_id }) || {}

      this.customer = Object.assign(this.customer, {
        cluster_name: cluster?.cluster_name || '',
        customer_code: memo.customer?.customer_code || '',
        customer_name: memo.customer?.customer_name || '',
        contact_person: memo.customer?.contact_person || '',
        address: memo.customer?.address || ''
      })

      this.formMemo = Object.assign(this.formMemo, {
        id: '',
        customer_memo_id: memo.id,
        customer_memo_name: memo.memo?.memo_name || '',
        schedule: moment().format('YYYY-MM'),
        event_date: moment().format('YYYY-MM-DD'),
        attachment_path: '',
        attachments: [],
        deleted_files: [],
        is_signed: 0,
        remarks: ''
      })

      this.$refs.modalMemo.show()
    },

    editMemo (memo) {
      this.state.editing = true

      const dateFormat = 'YYYY-MM-DD'

      const minDay = moment(memo.schedule).subtract(2, 'years').startOf('year')
      const maxDay = moment(memo.schedule).add(50, 'years').endOf('year')

      this.formMemoValidation.rangeDate = Object.assign(this.formMemoValidation.rangeDate, {
        min: minDay.startOf('month').format(dateFormat),
        max: maxDay.endOf('month').format(dateFormat)
      })

      this.formMemoValidation.documents = memo.memo?.documents || []

      const clusters = memo.assignee?.clusters || []
      const cluster = find(clusters, { id: memo.customer?.cluster_id }) || {}

      this.customer = Object.assign(this.customer, {
        cluster_name: cluster?.cluster_name || '',
        customer_code: memo.customer?.customer_code || '',
        customer_name: memo.customer?.customer_name || '',
        contact_person: memo.customer?.contact_person || '',
        address: memo.customer?.address || ''
      })

      this.formMemo = Object.assign(this.formMemo, {
        id: memo.id,
        customer_memo_id: memo.id,
        schedule: memo.schedule,
        event_date: memo.event_date,
        attachment_path: memo?.attachment_path || '',
        attachments: memo?.attachments || [],
        deleted_files: [],
        is_signed: memo.is_signed,
        remarks: memo?.remarks || ''
      })

      this.$refs.modalMemo.show()
    },

    updateCustomerMemoDocuments (attachment) {
      this.formMemo = Object.assign(this.formMemo, {
        attachment_path: attachment?.attachment_path || '',
        attachments: attachment?.attachments || [],
        deleted_files: attachment?.deleted_files || []
      })
    },

    validateCustomerMemo () {
      this.$refs.formMemo.validate().then(
        validMemo => {
          if (!validMemo) {
            return this.swalInvalid()
          }

          const hasNoAttachments = this.formMemo.attachments.length === 0

          const hasRequiredDocuments = this.formMemoValidation.documents.filter(
            documentType => Number(documentType.required) === 1
          ).map(
            documentType => ({
              name: documentType.document_type_name,
              uploaded: this.formMemo.attachments.some(
                attachment => Number(attachment.document_type_id) === Number(documentType.id)
              )
            })
          )

          if (hasNoAttachments || !hasRequiredDocuments.every(doc => doc.uploaded)) {
            const requiredDocuments = hasRequiredDocuments.filter(doc => !doc.uploaded).map(doc => doc.name).join(', ')
            const refAttachment = this.$refs.attachmentUploader
            if (refAttachment) {
              refAttachment.$refs.formDocument.setErrors({
                attachments: `Please upload at least one attachment for ${requiredDocuments}.`
              })
            }

            return this.swalInvalid()
          }

          return this.swalConfirm({
            html: `${this.state.editing ? 'Update' : 'Submit'} this Customer Memo?`,
            confirmButtonText: this.state.editing ? 'Update' : 'Submit',
            preConfirm: () => {
              this.state.busy = true

              const createOrUpdate = () => {
                return this.state.editing ? this.putMemo() : this.postMemo()
              }

              return createOrUpdate().catch(
                ({ message }) => {
                  if (message && message?.error) {
                    this.$refs.formMemo.setErrors(message.error)
                  }
                }
              ).finally(() => {
                this.state.busy = false
              })
            }
          })
        }
      )
    },

    async postMemo () {
      return SFSOCustomerMemo.post(this.formMemo).then(
        ({ data }) => {
          this.$refs.modalMemo.hide()

          this.swalSuccess(data.message).then(() => {
            this.$emit('update:rows')
          })
        }
      )
    },

    async putMemo () {
      return SFSOCustomerMemo.put(this.formMemo).then(
        ({ data }) => {
          this.$refs.modalMemo.hide()

          this.swalSuccess(data.message).then(() => {
            this.$emit('update:row', data.customer_memo)
          })
        }
      )
    },

    eventModalHidden () {
      this.detachArrowScroller('.nav-customer-memo-tabs')

      if (this.geoLocationId) {
        navigator.geolocation.clearWatch(this.geoLocationId)
        this.geoLocationId = null
      }
    },

    eventModalShown () {
      this.attachArrowScroller('.nav-customer-memo-tabs')

      const mapLibre = document.getElementById('mapLibre')
      if (mapLibre) {
        this.initMapLibre()
      } else {
        this.initLocationWatcher()
      }
    },

    initMapLibre () {
      const map = new Map({
        container: 'mapLibre',
        style: `${process.env.VUE_APP_MAP_TILER_STYLE}?key=${process.env.VUE_APP_MAP_TILER_KEY}`,
        center: [121.5886181, 16.6965175], // Aljay
        zoom: 17,
        maxZoom: 18,
        minZoom: 17,
        interactive: true,
        doubleClickZoom: false,
        maxBounds: [
          [116.0, 5], // Southwest coordinates
          [127.0, 21.5] // Northeast coordinates
        ]
      })
      const navigation = new NavigationControl()
      const geolocate = new GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true
        },
        trackUserLocation: true
      })

      geolocate.on('geolocate', officerPosition => {
        if (officerPosition?.coords) {
          const { longitude, latitude } = officerPosition.coords
          this.formMemo.geolocation = {
            longitude,
            latitude
          }
        }

        geolocate._geolocateButton.setAttribute('disabled', true)
      })

      map.on('styleimagemissing', task => {
        if (task.id === ' ') {
          // nothing to do here, just to avoid warning for missing image of map-libre-gl render
        }
      })

      map.addControl(geolocate, 'bottom-right')
      map.addControl(navigation, 'bottom-right')
      map.on('dblclick', () => {
        map.flyTo({
          duration: 1.25,
          easing (t) {
            return t * t * t
          },
          curve: 1,
          // offset: [0, 0],
          animate: true,
          essential: true,
          center: [
            geolocate._lastKnownPosition.coords.longitude,
            geolocate._lastKnownPosition.coords.latitude
          ],
          zoom: 17
        })
      })
      map.once('load', () => {
        const mapImage = new Image(5, 5)
        mapImage.src = imgLogo
        map.addImage(' ', mapImage)

        if (this.state.editing) {
          if (this.formMemo.geolocation) {
            const { longitude, latitude } = this.formMemo.geolocation

            const userCoords = [
              longitude,
              latitude
            ]

            if (longitude !== 0 && latitude !== 0) {
              map.flyTo({
                duration: 2.25,
                easing: t => t * t * t,
                // offset: [0, 0],
                animate: true,
                essential: true,
                center: userCoords
              })
            }
          }

          return
        }

        geolocate.trigger()
      })

      map.on('error', () => {
        if (!this.state.editing) {
          this.initLocationWatcher()
        }
      })
    },

    initLocationWatcher () {
      this.geoLocationId = navigator.geolocation.watchPosition(
        ({ coords }) => {
          this.formMemo.geolocation = {
            longitude: coords?.longitude || '',
            latitude: coords?.latitude || ''
          }
        },
        () => {
          this.formMemo.geolocation = {
            longitude: '',
            latitude: ''
          }
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      )
    }
  }
}
</script>
